module.exports = __webpack_public_path__ + "img/05.32593600.png";